import { Context } from "./Context";
import { Row } from "./Row";
import React, { useContext } from "react";

export function RowRenderer({ upTrend, mobile }) {
    const sortedRows = (rows, sortItems) => {
        const sortField = sortItems.sortField
        const sortOrder = sortItems.sortOrder

        if (sortField) {
            return [...rows].sort((a, b) => {
                if (a[sortField] === null) return 1;
                if (b[sortField] === null) return -1;
                if (a[sortField] === null && b[sortField] === null) return 0;

                return (a[sortField] - b[sortField]) * (sortOrder === "asc" ? 1 : -1)

            })
        }
    }

    const { contextData } = useContext(Context);
    const sortItems = contextData.sort
    // const loadedRows = loadFromLocalStorage('rows', true) ? loadFromLocalStorage('rows', true) : []
    const rows = sortItems ? sortedRows(contextData.rows, sortItems) : contextData.rows;
    let selectedStocks
    if (contextData['selectedStocks']) {
        selectedStocks = contextData['selectedStocks'].map(selectedStock => selectedStock.id)
        for (let i = 0; i < selectedStocks.length; i++) {
            const selectedStock = selectedStocks[i]
            if (selectedStock === 303) {
                selectedStocks.push(313)
            }
            if (selectedStock === 305) {
                selectedStocks.push(380)
            }
            if (selectedStock === 400) {
                selectedStocks.push(403)
                selectedStocks.push(404)
            }
            if (selectedStock === 311) {
                selectedStocks.push(320)
            }
            if (selectedStock === 312) {
                selectedStocks.push(321)
            }
        }
    } else {
        selectedStocks = []
    }
    const showSelectedSymbols = contextData['showSelectedSymbols']
    const trend = contextData['trend']
    const searchedSymbols = contextData['searchedSymbols']
    const selectedSymbols = contextData['selectedSymbols'] ? contextData['selectedSymbols'].map(item => item.value) : []
    return rows ? rows.map((item, index) => {
        const searchedSymbolCondition = searchedSymbols ? item['l18'].includes(contextData['searchedSymbols']) : true
        const selectedStockCondition = selectedStocks.length > 0 ? !!selectedStocks.includes(item['stock']) : true
        const selectedStockIsBlockCondition =
            selectedStockCondition
                ?
                true
                :
                selectedStocks.includes('block')
                    ?
                    [2, 3, 4].includes(item['l18'].slice(-1))
                    :
                    true
        const mobileTrendCondition = mobile === true ? true : upTrend === true ? item['ind_buy_to_sell_ratio'] > item['lowest_past_cross_value'] : item['ind_buy_to_sell_ratio'] < item['lowest_past_cross_value']
        const showSelectedSymbolsCondition = showSelectedSymbols ? selectedSymbols.includes(item['tse_url']) : true

        let toggleTrendCondition
        if (mobile) {
            switch (trend) {
                case "1":
                    toggleTrendCondition = true
                    break;
                case "2":
                    toggleTrendCondition = item['ind_buy_to_sell_ratio'] > item['lowest_past_cross_value']
                    break;
                case "3":
                    toggleTrendCondition = item['ind_buy_to_sell_ratio'] < item['lowest_past_cross_value']
                    break;
                default:
                    toggleTrendCondition = true
            }
        } else {
            toggleTrendCondition = true
        }
        const rowDisplayToggleStyle = showSelectedSymbolsCondition && searchedSymbolCondition && toggleTrendCondition && selectedStockCondition && mobileTrendCondition && selectedStockIsBlockCondition ? { display: 'table-row' } : { display: 'none' }
        return (<tr key={index} style={rowDisplayToggleStyle}>
            <Row item={item} upTrend={upTrend} />
        </tr>)
    }) : 'no data'


}
